import { useEffect, useRef } from 'react';

// Tickets belong to one mounted account/session context, not just matching IDs.
// Named sequences also reject older responses within that context.
export function useRequestContext(key) {
  const ref = useRef(null);
  if (!ref.current || ref.current.key !== key) {
    if (ref.current) ref.current.active = false;
    ref.current = { key, active: false, generation: 0, sequences: {} };
  }
  const context = ref.current;
  useEffect(() => {
    context.active = true;
    return () => { context.active = false; context.generation += 1; };
  }, [context]);
  const begin = (channel) => {
    const generation = context.generation;
    const sequence = channel ? (context.sequences[channel] || 0) + 1 : null;
    if (channel) context.sequences[channel] = sequence;
    return () => ref.current === context && context.active && context.generation === generation
      && (!channel || context.sequences[channel] === sequence);
  };
  return { begin };
}
